import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';

const Route104Banner = ({language}) => {
    return (
        <section className="route104-banner">
            <div className="route104-header mx-2 mb-5">
                {language === "Chinese" ? <h1>103K挑戰路線 <span className='theme-color ms-5'><em> The Race</em></span></h1>
                    : <h1>103K ROUTE <span className='theme-color ms-5'><em> The Race</em></span></h1>}

            </div>
            <Container>
                <Row className='align-items-center'>
                    <Col md={6} className='px-3'>
                        <h3 className='font-italic mx-4 my-3'><em>{language === "Chinese" ? "組別資訊" : "CATEGORY INFO"}</em></h3>
                        <ul>
                            <li>{language === "Chinese" ? "報名費：NT$4,500元" : "Entry Fee: NT$4,500"}</li>
                            <li>{language === "Chinese" ? "競賽資訊：本組別取男女前三名，並設置2個登山王（KOM）計時路段；103K電輔車組同路線騎乘，報名費相同，不列入競賽排名。" : "Competition: Top 3 men and top 3 women are awarded, and the route includes two King of the Mountains (KOM) timed segments. The 103K E-bike category rides the same route for the same entry fee but is not ranked."}</li>
                            <li>{language === "Chinese" ? "報名資格：身心健康且具有良好、純熟單車騎乘技術及經驗，體能適應強度可以在6小時內完騎，並無條件願意踏實遵守道路交通規則與大會交通維運工作人員引導、安全騎乘者，即符合資格。" : "Eligibility: Open to riders in good physical and mental health with solid, experienced bike-handling skills and the fitness to finish within 6 hours. Riders must agree to strictly obey traffic regulations, follow the instructions of event traffic control staff, and ride safely."}</li>
                            <p className='danger'>{language === "Chinese" ? "※103K挑戰組（含電輔車組）限7歲以上報名，未滿16歲參加者須附監護人同意書。" : "*103K The Race (including the E-bike category) is open to riders aged 7 and over. Riders under 16 must submit a parental/guardian consent form."}</p>
                            <li>{language === "Chinese" ? "計時方式：晶片計時" : "Timing: Chip timing"}</li>
                        </ul>
                    </Col>
                    <Col md={6} className='justify-content-center px-5'>
                        <table>
                            <thead>
                                <tr>
                                    <th>{language === "Chinese" ? "重要時程表" : "Key Times"}</th>
                                    <th>{language === "Chinese" ? "時間" : "Time"}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{language === "Chinese" ? "集合時間" : "Assembly Time"}</td>
                                    <td>05:00-05:30</td>
                                </tr>
                                <tr>
                                    <td>{language === "Chinese" ? "鳴槍時間" : "Start Time"}</td>
                                    <td>{language === "Chinese" ? "06:00-06:20（分批出發，電輔車組最後一批）" : "06:00-06:20 (wave starts; E-bikes in the final wave)"}</td>
                                </tr>
                                <tr>
                                    <td>{language === "Chinese" ? "時間限制" : "Time Limit"}</td>
                                    <td>{language === "Chinese" ? "6小時（依出發梯次，12:00-12:20關門）" : "6 hours (finish closes 12:00-12:20, depending on start wave)"}</td>
                                </tr>
                                <tr>
                                    <td>{language === "Chinese" ? "中途關門時間" : "Intermediate Cut-off"}</td>
                                    <td>{language === "Chinese" ? "11:00｜台21甲線20K+815頭社派出所前路口（逾時者請直接騎回向山會場）" : "11:00 | Junction in front of Toushe Police Station, Route 21A 20K+815 (riders past the cut-off must ride straight back to the Xiangshan venue)"}</td>
                                </tr>
                                {/* <tr>
                                    <td>{language === "Chinese" ? "衣物保管時間" : "Bag Drop"}</td>
                                    <td>05：00-13：30</td>
                                </tr> */}
                            </tbody>
                        </table>
                    </Col>
                </Row>
            </Container>
        </section>
    )
}

export default Route104Banner
